import React from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'];

const BrandAnalysis = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Brand & Item Type Analysis</h6>
                {data.by_brand && data.by_brand.length > 0 && (
                    <>
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Top Brands by Revenue</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Brand</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="text-end">Items</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_brand.map((b, i) => (
                                        <tr key={i}>
                                            <td>{b.brand_name}</td>
                                            <td className="text-end">{b.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{b.item_count}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {data.by_item_type && data.by_item_type.length > 0 && (
                    <div className="mt-3">
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Revenue by Item Type</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Type</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="text-end">Items</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_item_type.map((t, i) => (
                                        <tr key={i}>
                                            <td>{t.item_type}</td>
                                            <td className="text-end">{t.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{t.item_count}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BrandAnalysis;
